/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";

import { IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_ONE } from "../../../constants/signalRequestConsts";
import TablePaymentSlips from "./TablePaymentSlips";
import MySnackbar from "../../../components/MySnackbar";
import MySelectCompany from "../../../components/MySelectCompany";
import {
  getEmployeesPaymentSlipsSchemeTypesData,
  getEmployeesPaymentSlipsTypes,
  setEmployeesPaymentSlipsDataDownload,
} from "../../../api/signalApi";
import { setInMyChargeEmployeePaymentSlipsReset } from "../../../store/slices/userRequests";
import MyDatepicker from "../../../components/my-datepicker";
import dayjs, { Dayjs } from "dayjs";
import { startDownloadPaymentSlips } from "../../../api/s10DocumentsApi";


const VIEW_NAME = "Vista de Monitor de Descargas de Boletas de Pago";
const STATUS_URL = "/administracion/monitor-de-descargas-de-boletas-de-pago";

const AdminEmployeesPaymentSlips = ({
  viewType,
}: {
  viewType: "All" | "InMyCharge" | "ToApprove";
}) => {
    const dispatch = useDispatch<AppDispatch>();
    const { companyselected, connectionId } = useSelector(
        (state: RootState) => state.auth
    );
    const { payments, totalItems } = useSelector(
        (state: RootState) => state.userRequests
    )[IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_ONE];
    const { schemesTypes, paymentSlipsTypes } = useSelector((state: RootState) => state.userRequests);
    const {companies} = useSelector((state: RootState) => state.userRequests).approvalGroups;
    const [errorMsg, setErrorMsg] = useState<string>("");
    const [rucSelected, setRucSelected] = useState<string>("");

    const [pageSizeOne, setPageSizeOne] = useState<number>(25);
    const [pageOne, setPageOne] = useState<number>(2);
    const [schemeCode, setSchemeCode] = useState<string>("");
    const [paymentSlipType, setPaymentSlipType] = useState<string>("");
    const [startDate, setStartDate] = useState<Dayjs | null>(dayjs());
    const [endDate, setEndDate] = useState<Dayjs | null>(dayjs());

    const [modalOpen, setModalOpen] = useState<boolean>(false);

    useEffect(() => {
        if (!companyselected || !connectionId || !rucSelected) {
        return;
        }
        dispatch(setInMyChargeEmployeePaymentSlipsReset(IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_ONE));
        getEmployeesPaymentSlipsSchemeTypesData(rucSelected);
        getEmployeesPaymentSlipsTypes();
    }, [companyselected, connectionId, rucSelected]);

    useEffect(() => {
        if (!companyselected || !connectionId || !rucSelected || !schemeCode || !endDate || !paymentSlipType) {
        return;
        }
        tableOneRequest();
    }, [pageSizeOne, pageOne, rucSelected, schemeCode, startDate, endDate, paymentSlipType]);

    useEffect(() => {
        if (!schemesTypes.length || schemeCode) {
        return;
        }
        setSchemeCode(schemesTypes[0].NroEsquemaPlanilla);
    }, [schemesTypes]);

    useEffect(() => {
        if (!paymentSlipsTypes.length || paymentSlipType) {
        return;
        }
        setPaymentSlipType(paymentSlipsTypes[0].CodTablaTablas);
    }, [paymentSlipsTypes]);

    const formatDateForApi = (date: Date): string => {
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const tableOneRequest = () => {
        if (!startDate || !endDate) {
            return;
        }
        dispatch(setInMyChargeEmployeePaymentSlipsReset(IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_ONE));
        const startTime = formatDateForApi(startDate.toDate());
        const endTime = formatDateForApi(endDate.toDate());
        setEmployeesPaymentSlipsDataDownload(
            rucSelected,
            "",
            schemeCode,
            paymentSlipType,
            startTime,
            endTime,
            pageSizeOne,
            pageOne
        );
    };

    const handleStartDownload = async () => {
        if (!startDate || !endDate) {
            return;
        }
        const startTime = formatDateForApi(startDate.toDate());
        const endTime = formatDateForApi(endDate.toDate());
        const result = await startDownloadPaymentSlips(
            rucSelected,
            companies.find(c => c.RUC === rucSelected)?.Descripcion as any,
            paymentSlipType,
            paymentSlipsTypes.find(p => p.CodTablaTablas === paymentSlipType)?.Descripcion as any,
            schemeCode,
            schemesTypes.find(s => s.NroEsquemaPlanilla === schemeCode)?.Descripcion as any,
            startTime,
            endTime,
        );
        console.log(result);
        
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
    };

    const handleViewStatus = () => {
        window.location.href = STATUS_URL;
    };

    return (
        <Grid item width="100%" marginTop="1.5rem" minHeight="100%">
        <Paper
            elevation={3}
            style={{
            width: "100%",
            borderRadius: "0.5rem",
            minHeight: "10rem",
            padding: "2rem 1.5rem",
            }}
        >
            <Grid container spacing={2} direction="row">
            <MySelectCompany
                setRucSelected={setRucSelected}
                rucSelected={rucSelected}
            />
            <Grid item>
                <FormControl style={{ minWidth: "8rem" }}>
                <InputLabel id="select-option-label">Esquema</InputLabel>
                <Select
                    labelId="select-option-label"
                    id="select-option"
                    label={"Esquema"}
                    onChange={(event: { target: { value: string } }) => {
                    const value = event.target.value;
                    setSchemeCode(value);
                    }}
                    value={schemeCode}
                    style={{ height: "2.5rem", border: "none", backgroundColor: "white" }}
                >
                    {schemesTypes?.map((item, i) => (
                    <MenuItem key={i} value={item.NroEsquemaPlanilla}>
                        {item.Descripcion}
                    </MenuItem>
                    ))}
                </Select>
                </FormControl>
            </Grid>
            <Grid item>
                <FormControl style={{ minWidth: "8rem" }}>
                <InputLabel id="select-option-label">Tipo de nómina</InputLabel>
                <Select
                    labelId="select-option-label"
                    id="select-option"
                    label={"Tipo de nómina"}
                    onChange={(event: { target: { value: string } }) => {
                    const value = event.target.value;
                    setPaymentSlipType(value);
                    }}
                    value={paymentSlipType}
                    style={{ height: "2.5rem", border: "none", backgroundColor: "white" }}
                >
                    {paymentSlipsTypes?.map((item, i) => (
                    <MenuItem key={i} value={item.CodTablaTablas}>
                        {item.Descripcion}
                    </MenuItem>
                    ))}
                </Select>
                </FormControl>
            </Grid>
            <Grid item>
                <MyDatepicker
                defaultLabel="Fecha Inicio"
                value={startDate}
                setSelectedDate={(value) => {
                    setStartDate(value?.endOf("day") || null);
                    if (endDate) {
                    const dateDaysDiff = dayjs(value).diff(endDate, "day");
                    console.log(dateDaysDiff);
                    if (dateDaysDiff > 0) {
                        setEndDate(null);
                    }
                    }
                }}
                />
            </Grid>
            <Grid item>
                <MyDatepicker
                defaultLabel="Fecha Fin"
                value={endDate}
                minDate={startDate}
                setSelectedDate={(value: Dayjs | null) =>
                    setEndDate(value?.endOf("day") || null)
                }
                />
            </Grid>
            </Grid>
            <Grid container spacing={2} direction="row" sx={{ mt: ".25em" }}>
            <Grid item>
                <Button
                variant="contained"
                onClick={handleStartDownload}
                color="primary"
                disabled={!payments.length}
                >
                Iniciar descarga
                </Button>
            </Grid>
            </Grid>
            <TablePaymentSlips
                requestId={IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_ONE}
                page={pageOne}
                setPage={setPageOne}
                pageSize={pageSizeOne}
                setPageSize={setPageSizeOne}
            />
        </Paper>

        <Dialog open={modalOpen} onClose={handleCloseModal}>
            <DialogTitle>Descarga iniciada</DialogTitle>
            <DialogContent>
            <DialogContentText>
                La descarga ha comenzado. Puedes consultar el estado de la descarga en
                <strong> {VIEW_NAME}</strong>.
            </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={handleCloseModal} color="primary">
                Aceptar
            </Button>
            <Button onClick={handleViewStatus} color="primary" variant="contained">
                Ver estado
            </Button>
            </DialogActions>
        </Dialog>

        {errorMsg && (
            <MySnackbar
            msg={errorMsg}
            severity={"error"}
            open={!!errorMsg}
            onClose={() => {
                setErrorMsg("");
            }}
            />
        )}
        </Grid>
    );
};

export default AdminEmployeesPaymentSlips;